import React from 'react'
import * as styles from './Section.module.scss'

interface SectionProps {
  backgroundColor?: string
  paddingLarge?: string
  paddingMedium?: string
  paddingSmall?: string
  className?: string
  children: React.ReactNode
  overflow?: boolean
}

const Section: React.FC<SectionProps> = ({
  backgroundColor,
  paddingLarge,
  paddingMedium,
  paddingSmall,
  className,
  children,
  overflow
}) => {
  const classNames = [
    styles.section,
    paddingSmall && styles['section--paddingSmall'],
    paddingMedium && styles['section--paddingMedium'],
    paddingLarge && styles['section--paddingLarge']
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <section
      className={
        classNames +
        (className ? ` ${className}` : ' ') +
        (overflow ? styles.overflow : '')
      }
      style={
        {
          backgroundColor,
          '--padding-small': paddingSmall,
          '--padding-medium': paddingMedium,
          '--padding-large': paddingLarge
        } as React.CSSProperties
      }
    >
      {children}
    </section>
  )
}

export default Section

// Section container
const SectionContainer = ({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={styles.sectionContainer + (className ? ` ${className}` : '')}
    >
      {children}
    </div>
  )
}

export { SectionContainer }

/* example:
      <Section
        paddingMedium='6.5rem 0'
        paddingLarge='16.5rem 3rem'
        backgroundColor='var(--color-gray-50)'
        overflow={true}
      >
        // Can use antyhing here but also have SectionContainer for centering
        <SectionContainer>
          Hello world
        </SectionContainer>
      </Section>
*/
